import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { ContractDetailDto, ContractQueryInputDto, ContractResponseDto, FomentContractDto, GetFomentContractsInputDto, LogisticsActivitiesListResultDto } from '../dtos/integrations/bio-forest-abp/models';

@Injectable({
  providedIn: 'root',
})
export class BioForestAbpService {
  private restService = inject(RestService);
  apiName = 'Orchestrator';
  

  existsHarvestActivityReportForStand = (standLocationId: number, reasonCode: string, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: `/api/orchestrator/bioforest-abp/harvest/activity-reports/stands/${standLocationId}/reasons/${reasonCode}/exists`,
    },
    { apiName: this.apiName,...config });
  

  existsHarvestServiceOrderForStand = (standLocationId: number, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: `/api/orchestrator/bioforest-abp/harvest/service-order-stands/${standLocationId}/exists`,
    },
    { apiName: this.apiName,...config });
  

  existsSilvicultureServiceOrderForStand = (standLocationId: number, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: `/api/orchestrator/bioforest-abp/silviculture-service-orders/stands/${standLocationId}/exists`,
    },
    { apiName: this.apiName,...config });
  

  existsWoodStand = (standId: number, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, boolean>({
      method: 'GET',
      url: `/api/orchestrator/bioforest-abp/wood-stands/${standId}/exists`,
    },
    { apiName: this.apiName,...config });
  

  getContractDetail = (contractId: number, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, ContractDetailDto>({
      method: 'GET',
      url: `/api/orchestrator/bioforest-abp/contracts/${contractId}/detail`,
    },
    { apiName: this.apiName,...config });
  

  getContracts = (input: ContractQueryInputDto, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ContractResponseDto>>({
      method: 'GET',
      url: '/api/orchestrator/bioforest-abp/contracts',
      params: { contractTypeId: input.contractTypeId, contractTypeGroupId: input.contractTypeGroupId, contractMasterGroupCode: input.contractMasterGroupCode, number: input.number, fomentContractId: input.fomentContractId, vendorId: input.vendorId, isActive: input.isActive, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getFomentContracts = (input: GetFomentContractsInputDto, cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<FomentContractDto>>({
      method: 'GET',
      url: '/api/orchestrator/bioforest-abp/foment-contracts',
      params: { vendorId: input.vendorId, number: input.number, ids: input.ids, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getLogisticsActivities = (cancellationToken: any, config?: Partial<Rest.Config>) =>
    this.restService.request<any, LogisticsActivitiesListResultDto>({
      method: 'GET',
      url: '/api/orchestrator/bioforest-abp/logistics-activities',
    },
    { apiName: this.apiName,...config });
}